/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Shadow_Color_Aria_LabelInputs */

const en_styles_shadow_color_aria_label = /** @type {(inputs: Styles_Shadow_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shadow Color`)
};

const fr_styles_shadow_color_aria_label = /** @type {(inputs: Styles_Shadow_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur d'ombre`)
};

const de_styles_shadow_color_aria_label = /** @type {(inputs: Styles_Shadow_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schattenfarbe`)
};

const it_styles_shadow_color_aria_label = /** @type {(inputs: Styles_Shadow_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore ombra`)
};

const ru_styles_shadow_color_aria_label = /** @type {(inputs: Styles_Shadow_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цвет тени`)
};

const es_styles_shadow_color_aria_label = /** @type {(inputs: Styles_Shadow_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color de sombra`)
};

const zh_cn2_styles_shadow_color_aria_label = /** @type {(inputs: Styles_Shadow_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阴影颜色`)
};

const ja_styles_shadow_color_aria_label = /** @type {(inputs: Styles_Shadow_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`影の色`)
};

const hi_styles_shadow_color_aria_label = /** @type {(inputs: Styles_Shadow_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छाया रंग`)
};

const pt_pt2_styles_shadow_color_aria_label = /** @type {(inputs: Styles_Shadow_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor da Sombra`)
};

/**
* | output |
* | --- |
* | "Shadow Color" |
*
* @param {Styles_Shadow_Color_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_shadow_color_aria_label = /** @type {((inputs?: Styles_Shadow_Color_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Shadow_Color_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_shadow_color_aria_label(inputs)
	if (locale === "de") return de_styles_shadow_color_aria_label(inputs)
	if (locale === "it") return it_styles_shadow_color_aria_label(inputs)
	if (locale === "ru") return ru_styles_shadow_color_aria_label(inputs)
	if (locale === "es") return es_styles_shadow_color_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_shadow_color_aria_label(inputs)
	if (locale === "ja") return ja_styles_shadow_color_aria_label(inputs)
	if (locale === "hi") return hi_styles_shadow_color_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_shadow_color_aria_label(inputs)
	return en_styles_shadow_color_aria_label(inputs)
});